import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Link } from "react-router-dom";
import { AuthActions } from "../../modules/auth";
import Box from "../../components/Box";
import Chart from "../../components/Chart";
import ListData from "../../components/ListData";
import TableData from "../../components/TableData";
import DatePicker from "../../components/DatePicker";
import MultiSelect from "../../components/MultiSelect";
import LoadingModal from "../../components/LoadingModal";

import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Icon
} from "semantic-ui-react";

import moment from "moment";

const { authOnLogout, authOnInit } = AuthActions;

const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;

class Stock extends Component {
  componentWillMount() {
    // this.props.authOnInit();
  }

  componentDidMount() {
    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.loadInitialAnalyticsState(start_date, end_date);
  }

  onLogout() {
    this.props.authOnLogout();
  }

  render() {
    const {
      net_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category,
      sales_by_category_chart,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category,
      gross_sales,
      void_number,
      voids,
      refunds,
      discounts,
      new_taxes,
      grns_chart,
      invoice_chart,
      total_cogs
    } = this.props;

    const gross_margin_value = {
      header: gross_margin.header,
      value: gross_margin.data_one.value
    };

    const totalOnline = {
      header: "Online Stores",
      value: locations.length
    };

    const barChartTemplate = {
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16
        }
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto"
        },
        text: null,
        align: "left",
        x: -5,
        y: 5
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px"
          }
        }
      },
      yAxis: [
        {
          title: {
            text: null
          }
        }
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042"
        }
      },
      labels: {
        items: []
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    const pieChartTemplate = {
      chart: {
        backgroundColor: "none",
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        verticalAlign: "top",
        height: 280,
        color: "#414042"
      },
      title: {
        text: null,
        align: "center",
        verticalAlign: "middle",
        color: "#414042",
        y: 8,
        style: {
          color: "#666874",
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Roboto"
        }
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        style: {
          fontWeight: 200,
          fontSize: 5
        }
      },
      plotOptions: {
        pie: {
          colors: [
            "#ed561b ",
            "#f58233 ",
            "#ffb91a ",
            "#fff263 ",
            "#3050d6 ",
            "#2f7ed8 ",
            "#4897e5 ",
            "#409b23 ",
            "#50b432 ",
            "#97bf2b ",
            "#b8d649 "
          ],
          dataLabels: {
            enabled: false,
            distance: 100,
            color: "#414042",
            style: {
              fontWeight: "400",
              color: "#414042"
            }
          },
          center: ["50%", "55%"]
        }
      },
      series: [],
      credits: {
        enabled: false
      }
    };

    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    // salesByStore['title']['text'] = 'SALES BY STORE';
    salesByStore["xAxis"]["categories"] = sales_by_store["categories"];
    salesByStore["series"] = sales_by_store["series"];
    const secondary_yAxis = {
      gridLineWidth: 0,
      title: {
        text: null
      },
      opposite: true
    };
    salesByStore["yAxis"].push(secondary_yAxis);

    const salesbyDay = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    salesbyDay["xAxis"]["categories"] = sales_by_day["categories"];
    salesbyDay["series"] = sales_by_day["series"];

    const salesbyHour = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyHour['title']['text'] = 'SALES BY HOUR';
    salesbyHour["xAxis"]["categories"] = sales_by_hour_chart["categories"];
    salesbyHour["series"] = sales_by_hour_chart["series"];

    const grnsChart = JSON.parse(JSON.stringify(barChartTemplate));

    grnsChart["xAxis"]["categories"] = grns_chart["categories"];
    grnsChart["series"] = grns_chart["series"];

    grnsChart["yAxis"].push(secondary_yAxis);

    const invoiceChart = JSON.parse(JSON.stringify(barChartTemplate));

    invoiceChart["xAxis"]["categories"] = invoice_chart["categories"];
    invoiceChart["series"] = invoice_chart["series"];

    invoiceChart["yAxis"].push(secondary_yAxis);

    let salesByCategory = { ...pieChartTemplate };
    salesByCategory["title"]["text"] = sales_by_category_chart["title"]["text"];
    salesByCategory["series"] = sales_by_category_chart["series"];

    let marginBystore = { data: { values: [] }, header: "Margin by Store" };
    all_locations_insights.map((item, index) => {
      let value = {
        category: { value: item.name },
        amt_cur: { value: item.gross_margin.data_one.value }
      };
      marginBystore["data"]["values"].push(value);
    });

    const basketSize = {
      header: "BASKET SUMMARY",
      data: {
        values: [
          {
            category: { value: total_orders.header },
            amt_cur: { value: total_orders.value }
          },
          {
            category: { value: avg_order_size.header },
            amt_cur: { value: avg_order_size.value }
          },
          {
            category: { value: avg_order_value.header },
            amt_cur: { value: avg_order_value.value }
          },
          {
            category: { value: void_number.header },
            amt_cur: { value: void_number.value },
            currency: "Rs."
          },
          {
            category: { value: top_basket_category.header },
            amt_cur: { value: top_basket_category.value }
          }
        ]
      }
    };
    const saleSummary = {
      header: "SALES SUMMARY",
      data: {
        values: [
          {
            category: { value: gross_sales.header },
            amt_cur: { value: gross_sales.value }
          },
          {
            category: { value: refunds.header },
            amt_cur: { value: refunds.value }
          },
          {
            category: { value: discounts.header },
            amt_cur: { value: discounts.value }
          },
          {
            category: { value: net_sales.header },
            amt_cur: { value: net_sales.value }
          },
          {
            category: { value: new_taxes.header },
            amt_cur: { value: new_taxes.value }
          }
        ]
      }
    };
    net_sales.header = "Total Revenue";
    return (
      <div>
        <div>
          <Grid.Row style={{ float: "right" }}>
            <Grid.Column>
              <MultiSelect />
            </Grid.Column>
            <Grid.Column>
              <div style={styles.datePicker}>
                <DatePicker />
              </div>
            </Grid.Column>
          </Grid.Row>
        </div>
        <div style={{ clear: "both" }}>
          <Header style={styles.mainHeadig} as="h3">
            INVENTORY INSIGHTS
          </Header>
          <Grid columns={5}>
            <Box componentData={net_sales} />
            <Box componentData={total_cogs} />
            <Box currency="Rs." componentData={gross_margin_value} />
            <Box componentData={total_orders} />
            <Box componentData={total_orders} />
          </Grid>
          <Grid columns={3}>
            <Chart title="GRNS" data={grnsChart} />
            <Chart title="INVOICES" data={invoiceChart} />
            <Chart title="INVENTORY VALUATION" data={salesbyDay} />
          </Grid>
          <Header style={styles.mainHeadig} as="h3">
            LOW STOCK ITEMS
          </Header>
          <Grid columns={2}>
            <TableData currency="Rs." componentData={sales_by_category} />
            <TableData currency="Rs." componentData={sales_by_category} />
          </Grid>
          <Header style={styles.mainHeadig} as="h3">
            INVENTORY ANALYSIS
          </Header>
          <Grid columns={2}>
            <TableData currency="Rs." componentData={sales_by_category} />
            <TableData currency="Rs." componentData={sales_by_category} />
          </Grid>
          <Grid columns={2}>
            <TableData currency="Rs." componentData={sales_by_category} />
            <TableData currency="Rs." componentData={sales_by_category} />
          </Grid>
          <Grid columns={2}>
            <TableData currency="Rs." componentData={sales_by_category} />
            <TableData currency="Rs." componentData={sales_by_category} />
          </Grid>
        </div>
      </div>
    );
  }
}

const styles = {
  topHeader: {
    backgroundColor: "#652d92",
    color: "white"
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874"
  },
  title: {
    padding: 10,
    fontSize: 22
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435"
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400
  }
};

const mapStateToProps = state => {
  return getSelectorAnalytics(state);
};

export default connect(mapStateToProps, { loadInitialAnalyticsState })(Stock);



// WEBPACK FOOTER //
// ./src/containers/Stock/index.js